// frontend/src/screens/inbox/InboxReadingScreen.tsx
import React, { useEffect, useState } from 'react';
import { View, ActivityIndicator, Text, StyleSheet } from 'react-native';
import { useRoute, RouteProp } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import { getInboxItemHtml } from '../../services/api/inboxApi';
import { useMarkInboxRead } from '../../services/queries/useInbox';
import { ReportView } from '../../components/inbox/ReportView';
import { NotificationsNavigatorParamList } from '../../navigation/NotificationsNavigator';

export function InboxReadingScreen() {
  const route = useRoute<RouteProp<NotificationsNavigatorParamList, 'InboxReading'>>();
  const { itemId } = route.params;
  const { theme } = useTheme();
  const { t } = useTranslation();
  const mode: 'light' | 'dark' = theme.id === 'kinetic' ? 'dark' : 'light';

  const [html, setHtml] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const markRead = useMarkInboxRead();

  useEffect(() => {
    let active = true;
    getInboxItemHtml(itemId, mode)
      .then((h) => {
        if (!active) return;
        setHtml(h);
        markRead.mutate(itemId); // mark read only once the report actually loaded
      })
      .catch((e) => active && setError(e.message));
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemId, mode]);

  if (error) {
    return (
      <View style={[styles.center, { backgroundColor: theme.colors.background }]}>
        <Text style={{ color: theme.colors.error }}>
          {t('inbox.failedToLoad', { defaultValue: 'Failed to load report' })}
        </Text>
      </View>
    );
  }
  if (html === null) {
    return (
      <View style={[styles.center, { backgroundColor: theme.colors.background }]}>
        <ActivityIndicator size="large" color={theme.colors.primary} />
      </View>
    );
  }
  return (
    <View style={{ flex: 1, backgroundColor: theme.colors.background }}>
      <ReportView html={html} />
    </View>
  );
}

const styles = StyleSheet.create({
  center: { flex: 1, justifyContent: 'center', alignItems: 'center', padding: 32 },
});
